<template>
  <div class="distributor-base">
    <router-view/>
      <div v-if="$route.meta.footer.show" class='distributor-footer-wrap'>
          <mt-tabbar fixed class="distributor-footer">
              <mt-tab-item class='item-wrap' id='distributor_home'>
                    <router-link :to="{name:'DistributorHome'}" class='item badge'>
                        <img src="@/assets/image/tab/home_pre.svg" class="image" v-if="distributor_selected=='DistributorHome'" />
                        <img src="@/assets/image/tab/home.png" class="image" v-else />
                        <span class='text'>{{ $t('distributor.menu.home') }}</span>
                        <div v-if="hasErrandBuyUnreadMessages" class="badge-tab-red"></div>
                    </router-link>
                </mt-tab-item>
              <mt-tab-item v-if="distributor && distributor.store_id==0" class='item-wrap' id='distributor_errand'>
                <router-link :to="{name:'DistributorErrand'}" class='item badge'>
                    <img src="../../assets/image/tab/paotui.svg" class="image" v-if="distributor_selected=='DistributorErrand'">
                    <img v-else src="../../assets/image/tab/paotui_nor.svg" class="image" />
                    <span class='text'>{{ $t('distributor.menu.errand') }}</span>
                    <div v-if="hasErrandSendUnreadMessages" class="badge-tab-red"></div>
                </router-link>
              </mt-tab-item>
              <mt-tab-item class='item-wrap' id='distributor_map'><router-link :to="{name:'DistributorMap'}" class='item'><img src="../../assets/image/tab/map.svg" class="image" v-if="distributor_selected=='DistributorMap'"><img v-else src="../../assets/image/tab/map_nor.svg" class="image" /><span class='text'>{{ $t('distributor.menu.map') }}</span></router-link></mt-tab-item>
              <mt-tab-item class='item-wrap' id='distributor_point_record'><router-link :to="{name:'DianShuJiLu'}" class='item'><img src="../../assets/image/tab/dingdan.svg" class="image" v-if="distributor_selected=='DianShuJiLu'"><img v-else src="../../assets/image/tab/dingdan_nor.svg" class="image" /><span class='text'>{{ $t('distributor.menu.point_record') }}</span></router-link></mt-tab-item>
              <!-- <mt-tab-item class='item-wrap' id='distributor_settle_list'><router-link :to="{name:'DistributorSettleList'}" class='item'><i v-bind:class='["iconfont", (distributor_selected=="distributor_settle_list")?"icon-coordinates_fill":"icon-coordinates"]' /><span class='text'>{{ $t('distributor.menu.wallet') }}</span></router-link></mt-tab-item> -->
              <mt-tab-item class='item-wrap' id='distributor_user'><router-link :to="{name:'DistributorUser'}" class='item'><img src="../../assets/image/tab/wode.svg" class="image" v-if="distributor_selected=='DistributorUser'"><img v-else src="../../assets/image/tab/wode_nor.svg" class="image" /><span class='text'>{{ $t('distributor.menu.my') }}</span></router-link></mt-tab-item>
          </mt-tabbar>

      </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getPosition, clearWatch } from '../../util/map'
export default {
  name: 'DistributorBase',
  data () {
    return {
      // distributor_selected: 'distributor_home'
    }
  },
  computed: {
    ...mapState({
      distributor: state => state.distributor.info,
      config: state => state.config.config,
      rooms: (state) => state.chatroom.rooms
    }),
    hasErrandBuyUnreadMessages: function () {
      const rooms = {}
      Object.keys(this.rooms)
        .filter((room) => room.startsWith('errand-buy'))
        .forEach((room) => { rooms[room] = this.rooms[room] })
      const messages = Object.values(rooms).reduce((prev, current) => {
        return prev.concat(current.messages)
      }, [])
      return messages.some((m) => m.readedAt === 0 && m.clientType !== 'distributor')
    },
    hasErrandSendUnreadMessages: function () {
      const rooms = {}
      Object.keys(this.rooms)
        .filter((room) => room.startsWith('errand-send'))
        .forEach((room) => { rooms[room] = this.rooms[room] })
      const messages = Object.values(rooms).reduce((prev, current) => {
        return prev.concat(current.messages)
      }, [])
      return messages.some((m) => m.readedAt === 0 && m.clientType !== 'distributor')
    },
    distributor_selected() {
      return this.$route.name
    }
  },
  mounted: function () {
    let _this = this

    const info = {
      client_type: this.distributor.client_type,
      lat: this.distributor.lat ? this.distributor.lat : 0,
      lng: this.distributor.lng ? this.distributor.lng : 0
    }

    this.$socket.emit('distributors:add', info, (response) => {
      console.log('Socket - Add Distributor', response)
    })

    getPosition(function (res) {
      const location = { lat: res.coords.latitude, lng: res.coords.longitude }
      try {
        if (_this.distributor !== undefined && _this.distributor !== null) {
          console.log('Update Distributor Current Location', location)
          _this.distributorEdit(location)

        }
      } catch (e) {
        if (e instanceof TypeError) {
          // ingnore error
        }
      }
    }, (error) => {
      console.error(error)
    }, true)
  },
  beforeDestroy () {
    clearWatch()
  },
  methods: {
    ...mapMutations({
      distributorEdit: 'distributorEdit'
    })
  }
}
</script>
<style lang="scss" scoped>
  .image{
    width:1.5rem;
    height:1.5rem;
    display:block;
    margin-left:auto;
    margin-right:auto;
  }
</style>
